<div class="dropdown-nav" routerLinkActive="dropdown-nav-menu--active">
  <a
    *ngIf="dropdownNav.link"
    (mouseenter)="updateHovered(true)"
    (mouseleave)="updateHovered(false)"
    (focus)="updateHovered(true)"
    (focusout)="updateHovered(false)"
    class="btn-clean dropdown-nav-menu"
    role="menuitem"
    aria-haspopup="true"
    [attr.aria-label]="dropdownNav.ariaLabel"
    [attr.aria-expanded]="hovered$ | async"
    [routerLink]="dropdownNav.link"
    [queryParams]="dropdownNav?.queryParams"
    (click)="
      trackEvent({ category: 'Navigation', action: dropdownNav.trackEventAction, label: 'Titre', type: 'navigation' })
    "
  >
    {{ dropdownNav.label }}

    <mat-icon
      class="dropdown-nav-menu__icon"
      [class.dropdown-nav-menu__icon--hover]="(hovered$ | async) === true"
      svgIcon="arrow_next"
      role="presentation"
    ></mat-icon>
  </a>

  <button
    *ngIf="!dropdownNav.link"
    (mouseenter)="updateHovered(true)"
    (mouseleave)="updateHovered(false)"
    (focus)="updateHovered(true)"
    (focusout)="updateHovered(false)"
    class="btn-clean dropdown-nav-menu"
    role="menuitem"
    aria-haspopup="true"
    [attr.aria-label]="dropdownNav.ariaLabel"
    [attr.aria-expanded]="hovered$ | async"
  >
    {{ dropdownNav.label }}

    <mat-icon
      class="dropdown-nav-menu__icon"
      [class.dropdown-nav-menu__icon--hover]="(hovered$ | async) === true"
      svgIcon="arrow_next"
      role="presentation"
    ></mat-icon>
  </button>

  <ul
    [class.dropdown-nav-popup--display]="(hovered$ | async) === true"
    [class.dropdown-nav-popup--middle]="(position$ | async) === PopupPositionEnum.Middle"
    [class.dropdown-nav-popup--right]="(position$ | async) === PopupPositionEnum.Right"
    [class.dropdown-nav-popup--left]="(position$ | async) === PopupPositionEnum.Left"
    role="list"
    class="dropdown-nav-popup"
    (mouseenter)="updateInDropdown(true)"
    (mouseleave)="updateInDropdown(false)"
  >
    <li
      *ngFor="let item of dropdownNav.dropdownItems; trackBy: trackByDropdownItem"
      role="listitem"
      class="dropdown-nav-items__item"
    >
      <a
        class="dropdown-nav-items__item__link"
        [routerLink]="item.link"
        [fragment]="item.fragment"
        routerLinkActive="dropdown-nav-items__item__link--active"
        [queryParams]="item?.queryParams"
        [attr.aria-label]="item.ariaLabel"
        (click)="trackEvent({ category: 'Navigation', action: item.trackEventAction, type: 'navigation' })"
        (focus)="updateInDropdown(true)"
        (focusout)="updateHovered(false)"
        >{{ item.label }}</a
      >
    </li>
  </ul>
</div>
